import React from 'react';
import { FooterLink } from './FooterLink';
import store from '@apply/adminStore';

interface FooterProps {
    showAuthenticatedFooter?: boolean;
}

export const Footer: React.FC<FooterProps> = ({ showAuthenticatedFooter = false }) => {
    const { user } = store.getState();
    const copyrightMessage = '© 2025 Builder Finance. All rights reserved.';
    const phoneNumber = '800-752-0401';
    const footerLinkClass = () => {
        return `footerNav-link ${user.isBroker ? 'authenticated' : ''}`;
    };

    const termsOfServiceLink = () => {
        return (
            <FooterLink
                url='https://www.builderfinance.com/en/site-terms'
                className={footerLinkClass()}
            >
                Terms of Service
            </FooterLink>
        );
    };

    const privacyPolicyLink = () => {
        return (
            <FooterLink
                url='https://www.builderfinance.com/en/privacy-policy'
                className={footerLinkClass()}
            >
                Privacy Policy
            </FooterLink>
        );
    };

    return (
        <>
            <footer className={`${showAuthenticatedFooter ? 'authenticated' : ''}`}>
                {showAuthenticatedFooter ? (
                    <div className='footerContainer'>
                        <div className={`corporateWrapper ${user.isBroker ? 'authenticated' : ''}`}>
                            <a
                                href='/'
                                className='logo no-print'
                            >
                                <img
                                    src='/images/broker/footer-logo.png'
                                    alt='Builder Finance'
                                    width={'150px'}
                                />
                            </a>
                            <br />
                            <p className='corporateWrapper-disclaimer'>
                                Loans in the Draw section are not fully funded, but may or may not be eligible for draws
                            </p>
                            <p className='corporateWrapper-disclaimerrights'>{copyrightMessage}</p>
                        </div>
                        <div className={`footerNav ${user.isBroker ? 'authenticated' : ''}`}>
                            <div className='footerNav-linklist'>{termsOfServiceLink()}</div>
                            <div className='footerNav-linklist'>{privacyPolicyLink()}</div>
                            <div className='footerContact'>
                                <p>
                                    <b>Phone:</b> {phoneNumber}
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='footerContainer'>
                        <div className={`corporateWrapper ${user.isBroker ? 'authenticated' : ''}`}>
                            <p className='corporateWrapper-disclaimerrights'>{copyrightMessage}</p>
                        </div>
                        <div className={`footerNav ${user.isBroker ? 'authenticated' : ''}`}>
                            <span style={{ paddingRight: '5px' }}>{termsOfServiceLink()}</span> |
                            <span style={{ paddingLeft: '5px', paddingRight: '5px' }}>{privacyPolicyLink()}</span> |
                            <span style={{ paddingLeft: '5px' }}>
                                <b>Phone:</b>
                                <span style={{ color: '#112CA0', paddingLeft: '3px' }}>{phoneNumber}</span>
                            </span>
                        </div>
                    </div>
                )}
            </footer>
        </>
    );
};
